import React from 'react';
import Toast from './Toast';
import '../styles/Toast.css';

let toastListeners = [];
let toasts = [];

const showToast = (message, type = 'success', duration = 3000) => {
  // Check if a toast with the same message and type already exists
  const existingToast = toasts.find(
    toast => toast.message === message && toast.type === type
  );
  
  // If it already exists, don't create a new one
  if (existingToast) {
    return existingToast.id;
  }
  
  const id = Date.now();
  const newToast = { id, message, type, duration };
  toasts = [...toasts, newToast];
  toastListeners.forEach(listener => listener(toasts));
  
  return id;
};

const removeToast = (id) => {
  toasts = toasts.filter(toast => toast.id !== id);
  toastListeners.forEach(listener => listener(toasts));
};

const ToastContainer = () => {
  const [toastList, setToastList] = React.useState([]);

  React.useEffect(() => {
    const updateToasts = (newToasts) => {
      setToastList(newToasts);
    };
    
    toastListeners.push(updateToasts);
    setToastList(toasts);
    
    return () => {
      toastListeners = toastListeners.filter(listener => listener !== updateToasts);
    };
  }, []);

  return (
    <div className="toast-container">
      {toastList.map(toast => (
        <Toast
          key={toast.id}
          message={toast.message}
          type={toast.type}
          duration={toast.duration}
          onClose={() => removeToast(toast.id)}
        />
      ))}
    </div>
  );
};

export { showToast };
export default ToastContainer;

